import { render, staticRenderFns } from "./InspectionNG.vue?vue&type=template&id=1bb09230&scoped=true&"
import script from "./InspectionNG.vue?vue&type=script&lang=js&"
export * from "./InspectionNG.vue?vue&type=script&lang=js&"
import style0 from "./InspectionNG.vue?vue&type=style&index=0&id=1bb09230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb09230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VDataTable,VIcon,VSpacer,VToolbarTitle})
